import { escapeHtml } from "../util/escape-html.js";
export class NodeConflictDialogElement extends HTMLElement {
    #records = [];
    set records(value) { this.#records = value; this.render(); }
    get records() { return this.#records; }
    connectedCallback() { this.render(); }
    render() {
        const conflicts = this.#records.filter((record) => record.state === "conflict");
        this.innerHTML = conflicts.length === 0
            ? ""
            : `<dialog open aria-label="Sync conflicts"><form method="dialog"><h2>Review sync conflicts</h2>${conflicts.map((record) => `
        <article data-conflict-id="${escapeHtml(record.id)}"><strong>${escapeHtml(record.domain)}</strong>
          <p>This change needs a decision before replay can continue.</p>
          <button type="button" data-conflict-action="keep-local">Keep local</button>
          <button type="button" data-conflict-action="use-server">Use server</button>
        </article>`).join("")}<button>Close</button></form></dialog>`;
        this.querySelectorAll("[data-conflict-action]").forEach((button) => {
            button.addEventListener("click", () => {
                const article = button.closest("[data-conflict-id]");
                this.dispatchEvent(new CustomEvent("conflict-decision", {
                    bubbles: true,
                    composed: true,
                    detail: { action: button.dataset.conflictAction, id: article?.dataset.conflictId },
                }));
            });
        });
    }
}
//# sourceMappingURL=conflict-dialog.js.map